/**
 * Triggers stop-lines mapping prefetch at application boot.
 */

import React, { useEffect } from "react";

import { stopLinesService } from "../services/StopLinesService";

/**
 * Null-render component that loads the stop-lines mapping once on mount.
 */
export const StopLinesBootstrap: React.FC = () => {
    useEffect( () => {
        void stopLinesService.load();
    }, [] );

    return null;
};
